import React from "react";
import BlogSidebar from "../BlogSidebar/BlogSidebar";
import { featuredBlogPost, standardBlogPosts } from "../../config/blogs";
import BlogPostCard from "../BlogSection/BlogPostCard";

const BlogList: React.FC = () => {
  return (
    <section className="blog_details_section pt-120">
      <div className="container">
        <div className="row mt-none-50 g-0 align-items-start">
          <div className="col-lg-8 mt-50">
            <div className="blog_details_content">
              <div className="row mt-none-30">
                <div className="col-lg-12 mt-30">
                  <BlogPostCard post={featuredBlogPost} />
                </div>

                {standardBlogPosts.map((post) => (
                  <div className="col-lg-6 col-md-6 mt-30" key={post.id}>
                    <BlogPostCard post={post} small />
                  </div>
                ))}
              </div>
            </div>
          </div>
          <BlogSidebar />
        </div>
      </div>
    </section>
  );
};

export default BlogList;
